module.exports = __webpack_public_path__ + "media/images/sp/plans/mv_nightview@2x-07155825a71e2a12d28a980737ede8f8.webp";